import type { File } from "@zhihaoscm/entity";
import { BaseService } from "@/api/baseService";
import httpRequest from "@/api/index";

// 文件服务
export class FileService extends BaseService<any, any, any, any> {
    public async uploadFile(params: FormData): Promise<File> {
        const { data } = await this.service.post(`${this.path}/upload`, params);
        return data;
    }

    public async getFileById(id: number): Promise<File> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }

    public async getFileByIds(ids: number[]): Promise<File[]> {
        const { data } = await this.service.post(`${this.path}/ids`, ids);
        return data;
    }

    public async findById(id: number): Promise<File> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }
}
export const fileService = new FileService("/file", httpRequest);
